// some reused error messages.  there are other messages that live closer to where
// they are used, so this isn't a complete list
export const GOOGLE_LOGIN_ERROR_MESSAGE =
  'There was a problem with your Google account, please use your email instead';
export const DEFAULT_APPLE_LOGIN_ERROR_MESSAGE =
  'Error authenticating with Apple';
export const DEFAULT_GOOGLE_LOGIN_ERROR_MESSAGE =
  'Error authenticating with Google';
